const actionDataReceived = 'ACTION_DATA_RECEIVED';
const noDataReceived = 'NO_DATA_RECEIVED';
const errorReceived = 'ERROR_RECEIVED';
const requestingActionData = 'REQUESTING_ACTION_DATA';
const initialState = {
	actionData: {}, actionDataLoading: true
};

export const actionCreators = {

	getAction: (actionId) => async (dispatch) => {
		dispatch({ type: requestingActionData });
		const url = 'api/action/' + actionId + '/';

		const response = await fetch(url);
		if (response.ok) {
			const actionData = await response.json();
			dispatch({ type: actionDataReceived, actionData });
		}
		else if (response.status === 401) {
			const errorMessage = await response.text();
			dispatch({ type: errorReceived, errorMessage: errorMessage });
		}
		else {
			dispatch({ type: noDataReceived });
		}
	}
};

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === requestingActionData) {
		console.log("Requesting action data");
		return {
			...state,
			actionDataLoading: true,
			actionData: {},
			errorMessage: null,
		};
	}

	if (action.type === actionDataReceived) {
		console.log("Action data received");
		return {
			...state,
			actionDataLoading: false,
			actionData: action.actionData,
			errorMessage: null,
		};
	}
	if (action.type === noDataReceived) {
		console.log("No data received");
		return {
			...state,
			actionDataLoading: false,
			actionData: null,
			errorMessage: null,
		};
	}
	if (action.type === errorReceived) {
		console.log("Error recieved");
		return {
			...state,
			actionDataLoading: false,
			actionData: null,
			errorMessage: action.errorMessage
		};
	}
	return state;
};


// WEBPACK FOOTER //
// ./src/store/Action.js